<template>
    <section class="userSteps">
        <!-- <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div> -->
        <div class="publicProfile row align-items-center">
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('mannual_upload.text1')}} <span class="bgTitle">{{$t('mannual_upload.text2')}}</span></h3>
                </div>
            </div>
            <div class="col-12 col-md-10 mb-2">
                <h4 class="mb-2">{{$t('mannual_upload.text3')}}</h4>
                <p>{{$t('mannual_upload.text4')}}</p>
            </div>
            <div class="col-12 mb-2">
                <h4 class="mb-3">{{$t('mannual_upload.text5')}}</h4>
                <ul class="boxRadio selectIdenty d-flex align-items-center flex-wrap mb-4">
                    <li v-for="value,key in documentOptions" :key="key">
                        <label class="customCheckBox radio mb-0">
                            <img class="mb-1 document" height="50" :src="`${static_vars.imagePath}/assets/images/passport.svg`" :alt="$t('mannual_upload.text14')" :title="$t('mannual_upload.text14')" />
                            <span class="name medium f-15">{{value.name}}</span>
                            <input type="radio" name="radio" :id="'document'+key" v-model="documentType" :value="value.key" @change="changetype" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <div class="col-12 mb-2">
                <h4 class="mb-2">{{$t('mannual_upload.text6')}}</h4>
                <p class="mb-0">{{$t('mannual_upload.text7')}}</p>
                <p>{{$t('mannual_upload.text8')}}</p>
                <ul class="d-flex align-items-center pt-2 mb-4">
                    <li class="me-3"><img :src="`${static_vars.imagePath}/assets/images/good.png`" :alt="$t('mannual_proof.text14')" :title="$t('mannual_proof.text14')" /> </li>
                    <li class="me-3"><img :src="`${static_vars.imagePath}/assets/images/bad-s.png`" :alt="$t('mannual_proof.text15')" :title="$t('mannual_proof.text15')" /> </li>
                    <li><img :src="`${static_vars.imagePath}/assets/images/bad.png`" :alt="$t('mannual_proof.text14')" :title="$t('mannual_proof.text14')" /> </li>
                </ul>
            </div>
            <div class="col-12 col-md-7 mb-3">
                <h4 class="mb-2">{{$t('mannual_upload.text9')}}</h4>
                <div class="upload-btn-wrapper border-0">
                    <div class="beforeUplod flex-column justify-content-center align-items-center border p-3 position-relative" :class="(!file.name && !isBackoption) ? 'd-flex' : 'd-none'">
                        <img :src="`${static_vars.imagePath}/assets/images/upload.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{(documentType != 'PASSPORT') ? $t('mannual_upload.text15') : $t('mannual_upload.text16')}}</button>
                        <input type="file" name="myfile" id="fileUpload" ref="document" @change="setImage($event,'FRONT')"  />
                    </div>
                    <div class="afterUplod d-flex flex-column justify-content-center align-items-center p-3" v-if="file.name && !isBackoption" :class="[{'border p-2' : file.name}]">
                        <img :src="`${static_vars.imagePath}/assets/images/uploaded.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{$t('mannual_upload.text10')}}</button> 
                        <div class="position-relative d-flex align-items-center">
                            <p class="f-12 mb-0">{{file.name}} </p>
                            <a href="javascript:void(0)" class="delete" @click="clearDoc('FRONT')"><vue-feather size="14" type="trash-2"></vue-feather></a>
                        </div>
                       <div class="progress" v-if="file.name">
                            <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100"
                                aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                    <div class="beforeUplod d-flex flex-column justify-content-center align-items-center mt-2 border p-3 position-relative" :class="(isBackoption && !backfile.name && documentType != 'PASSPORT') ? 'd-flex' : 'd-none'">
                        <img :src="`${static_vars.imagePath}/assets/images/upload.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{$t('mannual_upload.text11')}}</button>
                        <input type="file" name="backfile" id="backfileUpload" ref="backdocument" @change="setImage($event,'BACK')"  />
                    </div>
                    <div class="afterUplod d-flex flex-column justify-content-center align-items-center p-3" v-if="isBackoption && backfile.name && documentType != 'PASSPORT'" :class="[{'border p-2' : backfile.name}]">
                        <img :src="`${static_vars.imagePath}/assets/images/uploaded.svg`" :alt="$t('mannual_proof.text16')" :title="$t('mannual_proof.text16')" />
                        <button class="btn">{{$t('mannual_upload.text12')}}</button> 
                        <div class="position-relative d-flex align-items-center">
                            <p class="f-12 mb-0">{{backfile.name}} </p>
                            <a href="javascript:void(0)" class="delete" @click="clearDoc('BACK')"><vue-feather size="14" type="trash-2"></vue-feather></a>
                        </div>
                       <div class="progress" v-if="isBackoption && backfile.name && documentType != 'PASSPORT'">
                            <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100"
                                aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <a href="javascript:void(0);" class="grd_btn full_size" :class="[{'disabled' : (isBackoption) ? (!documentType || !backfile.name) : (!file.name || !documentType)}]" @click="submit()"> {{$t('mannual_proof.text13')}}
                </a>
            </div>

        </div>
    </section>
</template>

<script>
import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
           file : {},
           documentType : 'PASSPORT',
           isBackoption : false,
            documentOptions : [
                {
                    name: "Passport",
                    text: "You will be providing image of your passport",
                    key: "PASSPORT",
                    back: false,
                    image: ''
                },
                {
                    name: "Driver's License",
                    text: "You will be providing image of your driving license",
                    key: "DRIVERS",
                    back: true,
                    image: ''
                },
                {
                    name: "Government issued ID",
                    text: "You will be providing image of any ID issued by government",
                    key: "ID",
                    back: true,
                    image: ''
                }
            ],
            backfile : {}
            
        }
    },
    methods:{
        changetype(){
           if(this.isBackoption){
            this.clearDoc('FRONT')
            this.clearDoc('BACK')
           }else{
            this.clearDoc('FRONT')
           }
           this.isBackoption = false
        },
        setImage(event,type){ 
            if(this.documentType != 'PASSPORT' && type == 'BACK'){
                this.backfile = event.target.files[0]
            }else if(type == 'FRONT'){
                this.file = event.target.files[0]
            }
        },
        clearDoc(type){
            if(type == 'FRONT'){
                document.getElementById("fileUpload").value = ''
                this.file = {}
            }else if(type == 'BACK'){
                document.getElementById("backfileUpload").value = ''
                this.backfile = {}
            }
        },
        submit(){
            let formData = new FormData();
            if(this.file.name){
                formData.append('document',this.file)
            }
            formData.append('documentType','PROOF_OF_IDENTITY')
            formData.append('documentSubType',this.documentType)
            if(this.isBackoption){
                formData.append('documentSide','BACK_SIDE')
            }else{
                formData.append('documentSide','FRONT_SIDE')
            }
            this.store.saveBrokerSumSubMannualDocument(formData,true,this.$route.params.id).then(() =>{
                if(this.documentType != 'PASSPORT'){
                    if(!this.isBackoption && this.documentType != 'PASSPORT'){
                        this.isBackoption = true
                    }else if(this.isBackoption && this.documentType != 'PASSPORT'){
                        this.$parent.documentStatus = 'UNDER_REVIEW'
                    }
                }else{
                    this.$parent.documentStatus = 'UNDER_REVIEW'
                }
            })
        }
    },
    created(){
        this.store.callUserBrokerStatusList({},false,this.$route.params.id).then(() => {
            if(Object.keys(this.store.brokerStatusList).length && Object.keys(this.store.brokerSettingsList).length){
                    this.store.$patch({'linkBrokerID' : null})
                    if(!this.store.brokerStatusList.completed){
                        if(this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE && this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE.length && ('currentStep' in this.store.brokerStatusList)){
                            let step = parseInt(this.store.brokerStatusList.currentStep) == 0 ? 0 : parseInt(this.store.brokerStatusList.currentStep)-1
                            if(parseInt(this.store.brokerStatusList.currentStep) == 6){
                                if (this.store.brokerStatusList.stepsStatus[step - 1].porStatus.status == 'REJECTED') {
                                    this.$router.replace({path : '/upload-por'+'/'+this.$route.params.id})
                                }else{
                                    this.$router.replace({path : '/sumsub'+'/'+this.$route.params.id})
                                }
                            }else{
                                this.$router.replace({path :this.store.StepsJson[this.store.brokerSettingsList.REGISTRATION_STEPS_MOBILE[step]]+'/'+this.$route.params.id})
                            }
                        }
                    }else{
                        if(this.store.userAccoutDetail.requiredActions && this.store.userAccoutDetail.requiredActions.length){
                            this.$router.replace({path : '/sutaibility'})
                        }else{
                            let path = `${this.static_vars.domainURL}dashboard`
                            window.location.replace(path)
                        }
                    }
                }
        })
    }
}
</script>